import React from 'react'
import { Helmet } from "react-helmet";
import Professional from '../../components/Courses/Professional/Professional';

const ProfessionalPage = () => {
  return (
    <>
    <Helmet>
      {/* Google Analytics Tag */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=AW-16818142902"></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-16818142902');
        `}
      </script>

      {/* Basic Meta */}
      <title>Professional Courses | Aptech Lekki Centre - Advance Your IT Career</title>
      <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      
      <meta
        name="description"
        content="Advance your career with Aptech Lekki's Professional IT Courses. Enroll in specialized programs like Project Management, Digital Marketing, Data Analytics, and Software Development. Get certified and gain a competitive edge in today’s tech-driven world."
      />
      
      <meta
        name="keywords"
        content="Professional IT courses Lekki, Certification programs Lagos, Project Management Training Nigeria, Digital Marketing course Lekki, Data analytics training Lagos, Career development IT, Upskill in tech Nigeria, Professional software development Lekki"
      />
      
      <meta name="author" content="Aptech Lekki Centre" />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href="https://aptechlekki.com/courses/professional" />

      {/* Open Graph Meta */}
      <meta property="og:title" content="Professional Courses | Aptech Lekki Centre" />
      <meta property="og:description" content="Explore career-boosting IT and Digital skills courses at Aptech Lekki. Get globally recognized certifications and advance your professional journey." />
      <meta property="og:url" content="https://aptechlekki.com/courses/professional" />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://aptechlekki.com/assets/og_image.jpg" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Professional Courses | Aptech Lekki Centre" />
      <meta name="twitter:description" content="Level up your tech career with Aptech Lekki's professional training and certifications. Join today!" />
      <meta name="twitter:image" content="https://aptechlekki.com/assets/og_image.jpg" />
    </Helmet>

    <Professional />
    </>
  )
}

export default ProfessionalPage